export const SCHEDULE_PLANNER_VIEWS = {
    MONTH: "month",
    DAY: "day"
};
